import { render, staticRenderFns } from "./LandingValuationPage.vue?vue&type=template&id=1749e9e8&scoped=true"
import script from "./LandingValuationPage.vue?vue&type=script&lang=ts"
export * from "./LandingValuationPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingValuationPage.vue?vue&type=style&index=0&id=1749e9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749e9e8",
  null
  
)

export default component.exports